"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternationalClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class InternationalClient extends base_client_1.ApiClient {
    constructor(config) {
        const baseURL = config.baseURL || process.env.INTERNATIONAL_BASE_URL;
        if (!baseURL) {
            throw new Error("INTERNATIONAL_BASE_URL is not set/provided");
        }
        let authEngine = core_auth_1.AuthEngine.COGNITO;
        let tokenRefreshFn = config.tokenRefreshFn;
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            authEngine = core_auth_1.AuthEngine.COGNITO_INTERNAL;
            tokenRefreshFn = tokenRefreshFn ?? new client_auth_1.OAuthClientTokenBuilder(config).getTokenFn();
        }
        super({ ...config, baseURL, authEngine, tokenRefreshFn });
    }
    async getSellerSettings(sellerId) {
        const response = await this.get(`/seller-settings/${sellerId}`);
        // if response is an empty string, we want to return undefined
        if (!response) {
            return undefined;
        }
        return response;
    }
    async createOrUpdateSellerSettings(sellerId, createOrUpdateSellerSettingsRequest) {
        return await this.put(`/seller-settings/${sellerId}`, createOrUpdateSellerSettingsRequest);
    }
    async getHsCodeMappings() {
        return await this.get(`/hs-code-mappings`);
    }
    async getShippingMethodFromCarrierCode(carrierCode, incoterm, sellerId, destinationCountryCode) {
        return await this.get(`/shipping-method/${carrierCode}`, {
            incoterm,
            sellerId,
            destinationCountryCode,
        });
    }
    async validateDims(validateDimsRequest) {
        return await this.post(`/dimensions/validate`, validateDimsRequest);
    }
}
exports.InternationalClient = InternationalClient;
//# sourceMappingURL=InternationalClient.js.map